import { Component } from "react";
import { h } from "h";
import TwoFactorSms from "../TwoFactorSms";

export default class TwoFactorSmsForm extends Component {
  render() {
    const { loading, mobile, note, error, actions } = this.props;
    const signin = { note, error, mobile, loading };

    return h(TwoFactorSms, { signin, actions });
  }
}
